@let offerValue = offer();
@let isVisibleOnScreenValue = isVisibleOnScreen();
@let hasEditValue = hasEdit();
@let canManageJobsValue = canManageJobs();
@let countersValue = counters();
@let followLoadingValue = followLoading();
@let detailsRouterLinkValue = detailsRouterLink();
@let fieldsVisibilityMapValue = fieldsVisibilityMap();
@let locationIdsValue = locationIds();
@let departmentLabelTooltipEnabledValue = departmentLabelTooltipEnabled();
@let hasPromoteValue = hasPromote();
@let hasElementsBeforePriorityValue = hasElementsBeforePriority();
@let shortenItemVersionValue = shortenItemVersion();

<div class="rt-card rt-card-clickable" padding>
  <div class="body">
    <div class="title-details">
      <div margin-bottom-small class="title">
        @if (fieldsVisibilityMapValue.title) {
          <span class="text">{{ offerValue.title }}</span>
        }
        @if (fieldsVisibilityMapValue.job_id) {
          <span class="badge-wrapper"
            ><rt-badge
              [text]="'#' + offerValue.guid"
              color="secondary"
              [rtClickToCopy]="offerValue.guid"
              [rtTooltip]="'app.offer.copy_id' | translate"
          /></span>
        }
        @if (offerValue.wysiwygEditor === 'redactor') {
          <span class="badge-wrapper"
            ><rt-badge
              [text]="'app.offer.action_needed' | translate"
              [color]="'warning-tint'"
              [iconName]="'warning'"
              [rtTooltip]="'app.offer.action_needed_tooltip' | translate"
          /></span>
        }
      </div>
      <div class="details">
        @if (!isVisibleOnScreenValue) {
          <rt-placeloader [class.disable-animations]="!isVisibleOnScreenValue" />
        }
        @if (isVisibleOnScreenValue) {
          @if (fieldsVisibilityMapValue.department && offerValue.department) {
            <span
              #departmentRef
              [rtTooltip]="offerValue.department"
              [rtTooltipPosition]="'below'"
              [rtTooltipEnabled]="departmentLabelTooltipEnabledValue"
              [class.restricted]="fieldsVisibilityMapValue.location && locationIdsValue.length"
              class="details-item department"
              text-weight-semi-bold
            >
              {{ offerValue.department }}
            </span>
          }
          <ng-container *ngTemplateOutlet="locationsDetails" />
          <ng-container *ngTemplateOutlet="workModelDetails" />
          <ng-container *ngTemplateOutlet="priorityDetails" />
        }
      </div>
    </div>
    <div class="actions">
      @if (!isVisibleOnScreenValue) {
        <rt-placeloader [class.disable-animations]="!isVisibleOnScreenValue" />
      }
      @if (isVisibleOnScreenValue) {
        <rt-group variant="horizontal">
          @if (hasPromoteValue) {
            <rt-button variant="outline" [routerLink]="['/offers', offerValue.slug, 'promote']">
              <rt-icon name="bullhorn" margin-right-small-xx />
              <span>{{ 'app.common.promote' | translate }}</span>
            </rt-button>
          }
          @if (hasEditValue) {
            <rt-button variant="outline" (click)="editOffer()">
              <rt-icon name="edit" />
              <span>{{ 'app.common.edit' | translate }}</span>
            </rt-button>
          }
          @if (canManageJobsValue) {
            <rt-job-actions-dropdown-container [job]="offerValue" margin-left-small-xx />
          }
        </rt-group>
      }
    </div>
  </div>
  @if (isVisibleOnScreenValue) {
    <rt-divider variant="medium line" />
    <div class="footer">
      <rt-offers-footer-counters [counters]="countersValue" />
      <div class="actions">
        @if (offerValue.jobScheduler) {
          <rt-job-scheduler-info
            [schedulerData]="offerValue.jobScheduler"
            margin-right-small
            padding-top-small-xx
          />
        }
        <rt-follow-button
          margin-left-small
          [type]="'offer'"
          [followed]="offerValue.followed"
          [loading]="followLoadingValue"
          [kind]="offerValue.kind"
          (followClick)="followClick()"
          (unfollowClick)="followClick()"
        />
        <rt-statuses-dropdown-container [offer]="offerValue" />
      </div>
    </div>
  }
  <a [routerLink]="detailsRouterLinkValue" class="details-link"></a>
</div>

<ng-template #locationsDetails>
  @if (fieldsVisibilityMapValue.location && locationIdsValue.length) {
    @if (fieldsVisibilityMapValue.department && offerValue.department) {
      <rt-divider variant="dot" />
    }
    <rt-assigned-locations-info-container [locationIds]="locationIdsValue" [showIcon]="true" />
  }
</ng-template>

<ng-template #workModelDetails>
  @if (
    (offerValue.onSite || offerValue.hybrid || offerValue.remote) &&
    fieldsVisibilityMapValue.work_model
  ) {
    @if (
      (fieldsVisibilityMapValue.department && offerValue.department) ||
      (fieldsVisibilityMapValue.location && locationIdsValue.length)
    ) {
      <rt-divider variant="dot" />
    }
    @if (offerValue.onSite) {
      <div class="details-item work-model">
        <rt-icon
          name="domain"
          [rtTooltip]="'app.offer_form.work_model_section.on_site.title' | translate"
          [rtTooltipEnabled]="shortenItemVersionValue"
          [rtTooltipPosition]="'below'"
          margin-right-small-xx
        />
        @if (!shortenItemVersion) {
          <span>{{ 'app.offer_form.work_model_section.on_site.title' | translate }}</span>
        }
      </div>
    }
    @if (offerValue.hybrid) {
      <div [attr.margin-left-small-x]="offerValue.onSite || null" class="details-item work-model">
        <rt-icon
          name="hybrid"
          [rtTooltip]="'app.offer_form.work_model_section.hybrid.title' | translate"
          [rtTooltipEnabled]="shortenItemVersionValue"
          [rtTooltipPosition]="'below'"
          margin-right-small-xx
        />
        @if (!shortenItemVersionValue) {
          <span>{{ 'app.offer_form.work_model_section.hybrid.title' | translate }}</span>
        }
      </div>
    }
    @if (offerValue.remote) {
      <div
        [attr.margin-left-small-x]="offerValue.onSite || offerValue.hybrid || null"
        class="details-item work-model"
      >
        <rt-icon
          name="nav-careershub"
          [rtTooltip]="'app.offer_form.work_model_section.remote.title' | translate"
          [rtTooltipEnabled]="shortenItemVersionValue"
          [rtTooltipPosition]="'below'"
          margin-right-small-xx
        />
        @if (!shortenItemVersionValue) {
          <span>{{ 'app.offer_form.work_model_section.remote.title' | translate }}</span>
        }
      </div>
    }
  }
</ng-template>

<ng-template #priorityDetails>
  @if (fieldsVisibilityMapValue.priority && offerValue.priority) {
    @if (hasElementsBeforePriorityValue) {
      <rt-divider variant="dot" />
    }
    <div class="details-item priority" layout-horizontal layout-align-items-center>
      <rt-icon
        [name]="priorityDataMap[offerValue.priority].icon!"
        [colorToken]="priorityDataMap[offerValue.priority].iconColorToken || 'colorIconDefault'"
        [rtTooltip]="priorityDataMap[offerValue.priority].label"
        [rtTooltipEnabled]="shortenItemVersionValue"
        [rtTooltipPosition]="'below'"
        margin-right-small-xx
      />
      @if (!shortenItemVersionValue) {
        <span>{{ priorityDataMap[offerValue.priority].label }}</span>
      }
    </div>
  }
</ng-template>
